import { Link } from 'react-router-dom';
import { Music, Plus } from 'lucide-react';

export function MusicMain() {
  return (
    <div className="container mx-auto px-4 py-8">
      <div className="flex items-center justify-between mb-6">
        <div className="flex items-center gap-3">
          <Music className="w-8 h-8 text-blue-600" />
          <h1 className="text-3xl font-bold">Music Assets</h1>
        </div>
        <Link
          to="/music/new"
          className="inline-flex items-center px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 transition-colors"
        >
          <Plus className="w-4 h-4 mr-2" />
          Upload Music
        </Link>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <p className="text-gray-600">Music assets dashboard coming soon...</p>
      </div>
    </div>
  );
}
